import React, { useEffect, useState } from "react";
import FileDownload from "js-file-download";
import axios from "axios";

// const env = import.meta.env;
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Fetch Incident Response Plan Test
export const fetchIRPTest = async (companyProfileID: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/Test/CompanyId/${companyProfileID}/Details`
    );

    // console.log("fetchIRPTest res", res);
    return res.data.data;
  } catch (error) {
    return error;
  }
};
//Fetch Incident Response Plan preview
export const fetchIRPTestPreview = async (testId: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/Test/id/${testId}/Details`
    );
    // console.log("fetchIRPTestPreview res", res);
    return res.data.data;
  } catch (error) {
    return error;
  }
};

//Create Incident Response Plan
export const CreateIRPTestPreview = async (payload: any) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/api/Plan/Test`, payload);
    // console.log("CreateIRPTestPreview res", res);
    return res.data;
  } catch (error) {
    return error;
  }
};

//Edit Incident Response Plan
export const EditIRPTestPreview = async (payload: any) => {
  try {
    const res = await axios.put(`${API_BASE_URL}/api/Plan/Test`, payload);
    return res.data;
  } catch (error) {
    return error;
  }
};
//Edit Incident Response Plan  test types
export const getIRPTestTypes = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/api/Plan/Test/Type`);
    // console.log("EditIRPTestPreview res", res);
    return res.data.data;
  } catch (error) {
    return error;
  }
};
//Delete Incident Response Plan  test types
export const deleteIRPTest = async (userId: number, testID: number) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/Test/${testID}/${userId}/Delete`
    );
    // console.log("deleteIRPTest res", res);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const downloadFiles = async (payload: any, companyProfileID: number) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/Plan/Test/Download/Document?companyProfileid=${companyProfileID}&Testid=${payload.testID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      FileDownload(response.data, `${payload.testName}.docx`);
    });
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Upload Files
export const uploadFilesIRPTest = async (
  file: File[],
  userId: number,
  testID: number
) => {
  try {
    if (file.length === 0) {
      throw new Error("File is undefined");
    }

    const formData = new FormData();
    file.forEach((singleFile) => {
      formData.append("files", singleFile);
    })

    const res = await axios.post(
      `${API_BASE_URL}/api/Plan/Test/Upload/Files?TestId=${testID}&createdBy=${userId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    //console.log("uploadFiles res", res);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//get Uploaded Files
export const getIRPTestFiles = async (testID: number) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/testid/${testID}/Files`);
    // console.log("getIRPTestFiles res", res);
    return res.data.data;
  } catch (error) {
    return error;
  }
};

//get Uploaded Files
export const getIRPTestFilesDownload = async (payload: any) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/Plan/Test/${payload.testID}/Download/File/${payload.testFilesInformationID}`,
      method: "GET",
      responseType: "blob", // Important
    }).then((response) => {
      // console.log("downloadFiles response", payload.fileName,);

      FileDownload(response.data, payload.testFileName);
    });
  } catch (error) {
    return error;
  }
};

//get Uploaded Files
export const downloadAllTestFiles = async (
  testDetails: any,
  userId: number,
  companyProfileid: number
) => {
  // console.log("downloadAllTestFiles response", testDetails);

  try {
    axios({
      url: `${API_BASE_URL}/api/Plan/Test/Download-All?Testid=${testDetails.testID}&Userid=${userId}&companyProfileid=${companyProfileid}`,
      method: "POST",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadAllTestFiles response", response);

      FileDownload(response.data, `${testDetails.testName}.zip`);
    });
  } catch (error) {
    return error;
  }
};

//get File Delete
export const getIRPTestFileDelete = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/Test/delete/Files`,
      payload
    );
    // console.log("deleteFiles res", res);
    return res.data;
  } catch (error) {
    return error;
  }
};
